import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import NumberFormat from 'react-number-format';

const CurrencyTextFieldCompat = ({
  onChange,
  currencySymbol,
  decimalCharacter = '.',
  decimalPlaces,
  outputFormat,
  modifyValueOnWheel,
  allowDecimalPadding,
  InputProps,
  ...props
}) => (
  <NumberFormat
    {...props}
    customInput={TextField}
    thousandSeparator=","
    decimalSeparator={decimalCharacter}
    decimalScale={decimalPlaces}
    allowNegative
    InputProps={
      currencySymbol
        ? {
            ...InputProps,
            startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
          }
        : InputProps
    }
    onValueChange={({ value }, sourceInfo) => {
      if (onChange) onChange(sourceInfo?.event, value);
    }}
  />
);

export default CurrencyTextFieldCompat;
